function isPlaybackInterruption(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}

/**
 * Starts playback without leaving an unhandled rejection behind.
 *
 * `play()` resolves only once playback actually starts, so pausing or switching
 * track before that rejects with an AbortError. Swallow it, report the rest via
 * `onError` (typically to reset the UI back to a paused state).
 */
export function safePlay(
  element: HTMLMediaElement,
  options: { onError?: (error: unknown) => void } = {},
): void {
  const started = element.play() as Promise<void> | undefined;
  if (!started) return;

  void started.catch((error: unknown) => {
    if (isPlaybackInterruption(error)) return;
    options.onError?.(error);
  });
}
